export const updateReferrers = (refer) => {
    let referrersJson = localStorage.getItem("referrers");

    let referrers;
    try {
        referrers = JSON.parse(referrersJson) || [];

    } catch (e) {
        referrers = [];
    }
    if (!referrers.includes(refer)) {
        referrers.push(refer);
        if (referrers.length > 20) {
            referrers.shift();
        }
    }
    localStorage.setItem("referrers", JSON.stringify(referrers));
}

export const clearReferrers = () => {
    localStorage.removeItem("referrers");
}